import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MasivechargeComponent } from '../masivecharge/masivecharge.component';

@Component({
  selector: 'app-madegoupdialog',
  templateUrl: './madegoupdialog.component.html',
  styleUrls: ['./madegoupdialog.component.scss'],
})
export class MadegoupdialogComponent implements OnInit {
  constructor(
    private router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MadegoupdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idGroup: string }
  ) {}

  ngOnInit(): void {}

  public goToPreRegister(): void {
    this.router.navigate([`pages/userdash/pre-register/${this.data.idGroup}`]);
    this.closeModal();
  }

  public openMasiveCharge(): void {
    this.dialog
      .open(MasivechargeComponent, {
        panelClass: 'position-modal',
        disableClose: true,
        data: {
          idGroup: this.data.idGroup,
        },
      })
      .afterClosed()
      .subscribe((rta: any) => {
        rta ? this.dialogRef.close(rta) : null;
      });
  }

  public closeModal(): void {
    this.dialogRef.close();
  }
}
